import React from 'react';
import { Link } from 'react-router-dom';
import { observer } from 'mobx-react';

// Config
import { config } from '../../../config';

// Translation
import translate from '../../translate/Translate';

// Components
import AssessmentCard from '../../common/AssessmentCard';
import Tooltip from '../../common/Tooltip';

const StudentHome = observer(
  class StudentHome extends React.Component {

    toggleTooltip = (e) => {
      const target = e.target;
      const tooltip = target.querySelector('.tooltip');

      if (tooltip) {
        tooltip.classList.toggle('tooltip--focused');
      }
    }

    render() {
      const { allCompleted, store, translation } = this.props;
      const { AppStore, AssessmentStore, UserStore } = store;
      const { assessments } = AssessmentStore;
      const { installSid } = UserStore;

      if (!AppStore.loading) {
        return (
          <main
            id="main-content"
            className="page"
            tabIndex="-1"
            aria-labelledby="page-title"
          >
            <div className="wrap">
              <div id="intro" className="page__intro">
                <h1 id="page-title" className="page__title">
                  {installSid !== config.gereSid ? translation.heading : translation.heading_gere}
                </h1>

                <p>
                  {installSid !== config.gereSid ? translation.body : translation.body_gere}
                </p>

                {installSid !== config.gereSid && allCompleted && (
                  <Link
                    to={`/report/intro?hideNotification=true`}
                    className="btn btn--prominent"
                    target="_blank"
                    onFocus={this.toggleTooltip}
                    onBlur={this.toggleTooltip}
                    rel="opener"
                  >
                    <Tooltip
                      content={translation.link_tooltip}
                      id="report-print"
                      icon={translation.plg_button}
                      brief
                      hideLabel
                      up
                    />
                  </Link>
                )}
              </div>

              <section id="assessments" aria-labelledby="assessments-heading">
                <h2 className='meta' id="assessments-heading">PLG Sections</h2>
                {assessments.length === 0 && !AppStore.loading && (
                  <span className="no-results panel">{translation.no_results}</span>
                )}

                {assessments.length > 0 && (
                  <ol className="list-reset">
                    {assessments.map((assessment, i) => (
                      <li key={`${assessment.assessmentSid}-${i}`}>
                        <AssessmentCard
                          id={`${assessment.assessmentSid}-${i}`}
                          {...this.props}
                          allCompleted={allCompleted}
                          assessment={assessment}
                        />
                      </li>
                    ))}
                  </ol>
                )}
              </section>
            </div>
          </main>
        );
      }

      return null;
    }
  }
);

export default translate('StudentHome')(StudentHome);
